import { useEffect, useRef, useState } from 'react';
import type { TextStyleValue } from '@elfsight/configurator-contracts';
import { clamp } from 'es-toolkit';

const RATIO_THRESHOLD = 0;

export function useAdaptiveFontSize(
  textStyle: TextStyleValue,
  value: string | number | undefined
) {
  const defaultFontSize = textStyle.fontSize;

  const [adaptiveFontSize, setAdaptiveFontSize] = useState(defaultFontSize);
  const containerRef = useRef<HTMLDivElement>(null);
  const textRef = useRef<HTMLDivElement>(null);

  const watchContainerWidth =
    containerRef?.current?.getBoundingClientRect().width;

  useEffect(() => {
    const checkFontSize = (fontSize: number): number => {
      const containerWidth =
        containerRef?.current?.getBoundingClientRect().width;
      const textWidth = textRef?.current?.getBoundingClientRect().width;

      if (containerWidth && textWidth && textWidth > containerWidth) {
        const ratio = (containerWidth - RATIO_THRESHOLD) / textWidth;
        return clamp(Math.floor(fontSize * ratio), 10, defaultFontSize);
      }

      return fontSize;
    };

    const id = requestAnimationFrame(() => {
      setAdaptiveFontSize(checkFontSize(defaultFontSize));
    });

    return () => {
      cancelAnimationFrame(id);
    };
  }, [value, defaultFontSize, watchContainerWidth]);

  return { containerRef, textRef, adaptiveFontSize };
}
